import { showErrorDialog } from 'store/errorDialog/actions';
import {
    DISMISS_ERROR_DIALOG,
    SHOW_ERROR_DIALOG,
} from 'store/errorDialog/constants';
import { ErrorDialogState } from 'store/errorDialog/reducer.types';

const initialState: ErrorDialogState = {
    error: {
        description: undefined,
        title: undefined,
        code: undefined,
    },
    isVisible: false,
};

const handlers = {
    [SHOW_ERROR_DIALOG](
        state: ErrorDialogState,
        {
            payload: { title, description, code },
        }: ReturnType<typeof showErrorDialog>,
    ): ErrorDialogState {
        return {
            ...state,
            error: {
                title,
                description,
                code,
            },
            isVisible: true,
        };
    },
    [DISMISS_ERROR_DIALOG](state: ErrorDialogState): ErrorDialogState {
        return {
            ...state,
            error: {
                title: undefined,
                description: undefined,
                code: undefined,
            },
            isVisible: false,
        };
    },
};

export default { initialState, handlers };
